import AddDeviceButton from './AddDeviceButton';

export default AddDeviceButton;
